import { render, staticRenderFns } from "./ImageReport.vue?vue&type=template&id=13dcc170&scoped=true&lang=pug&"
import script from "./ImageReport.vue?vue&type=script&lang=ts&"
export * from "./ImageReport.vue?vue&type=script&lang=ts&"
import style0 from "./ImageReport.vue?vue&type=style&index=0&id=13dcc170&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dcc170",
  null
  
)

export default component.exports